// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const zIndices = {
  languageTab: 1,
  editor: 1,
  tweatableSelection: 10,
}

export default zIndices
